<template>
    <div class="gp-vidio">
        <video id="gp-vidio" :src='require("../assets/vidio/" + vidio_Arr[vidio_Index].vidio_Src)'
            :poster='require("../assets/vidio/" + vidio_Arr[vidio_Index].vidio_Poster)' :index="vidio_Index"
            :indexData="vidio_Arr[vidio_Index].vidio_Src" controls="controls">
        </video>
    </div>
</template>

<script>

export default {
    name: 'gp-vidio',
    data() {
        return {
            vidio_Url: "@",
            vidio_Current_Src: '',
            vidio_Current_Poster: '',
            vidio_Arr: [
                {
                    vidio_Src: "MEIXUAN.mp4",
                    vidio_Poster: "SAMURAISHODOWN.jpg"
                }, {
                    vidio_Src: "KOF14.mp4",
                    vidio_Poster: "KOF14.jpg"
                }, {
                    vidio_Src: "WRC8.mp4",
                    vidio_Poster: "wrc8.jpg"
                },
                {
                    vidio_Src: "RhythmPlanet.mp4",
                    vidio_Poster: "RhythmPlanet.jpg"
                },
                {
                    vidio_Src: "KOF15.mp4",
                    vidio_Poster: "KOF15.jpg"
                },
                {
                    vidio_Src: "UD.mp4",
                    vidio_Poster: "UD.jpg"
                },
                {
                    vidio_Src: "Video01.mp4",
                    vidio_Poster: "Video01.jpg"
                },
                {
                    vidio_Src: "Video02.mp4",
                    vidio_Poster: "Video02.jpg"
                },
                {
                    vidio_Src: "Video03.mp4",
                    vidio_Poster: "Video03.jpg"
                },
                {
                    vidio_Src: "TowerOfFantacy.mp4",
                    vidio_Poster: "TowerOfFantacy.jpg"
                },
                {
                    vidio_Src: "FenyxRising.mp4",
                    vidio_Poster: "FenyxRising.jpg"
                },
                {
                    vidio_Src: "Horizon.mp4",
                    vidio_Poster: "Horizon.jpg"
                }
                ,
                {
                    vidio_Src: "Honkai_cn.mp4",
                    vidio_Poster: "Honkai.jpg"
                },
                {
                    vidio_Src: "Honkai_en.mp4",
                    vidio_Poster: "Honkai.jpg"
                }
            ]
        }
    },
    props: ['vidio_Index'],
    components: {
    },
    methods: {
    },
}
</script>

<style lang="scss">
.gp-vidio {
    width: 100vw;
    height: 100vh;
    background-color: #000000;
}

.gp-vidio video {
    height: calc(100% - 100px);
    width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/gp-vidio.vue